// extracted by mini-css-extract-plugin
export default {"closeChangeBtn":"CollapsableSelect--closeChangeBtn--M1TxV"};